import * as React from "react";

import { Divider } from "@impero-com/ui";
import { Typography } from "antd";

import * as theme from "./theme.css";

const { Text } = Typography;
interface HeadingMetadataFieldProps {
    id: string;
    name: string | undefined;
}

export default class HeadingMetadataField extends React.PureComponent<HeadingMetadataFieldProps> {
    render = () => {
        return (
            <div id={this.props.id}>
                <Divider>
                    {this.props.name !== undefined &&
                        this.props.name !== "" && (
                            <Text
                                type="secondary"
                                className={theme.headingMetadataFieldText}
                            >
                                {this.props.name.toLocaleUpperCase()}
                            </Text>
                        )}
                </Divider>
            </div>
        );
    };
}
